export default {
  departments: [],
  business_categories: [],
  project_statuses: [],
  user_types: [],
}